import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  TextField,
  useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface AddEnergyMeterRequestModalProps {
  open: boolean;
  onClose: () => void;
}

const AddEnergyMeterRequestModal: React.FC<AddEnergyMeterRequestModalProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const [description, setDescription] = useState('');

  const handleClose = () => {
    setDescription('');
    onClose();
  };

  const handleSend = () => {
    // Intentionally no action for now; will be implemented later
    console.log('Energy Meter request description:', description);
    handleClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        }
      }}
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 3, 
        pb: 2,
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" sx={{ 
            fontWeight: 600,
            color: theme.palette.text.primary,
            fontFamily: 'Montserrat, sans-serif'
          }}>
            Add Energy Meter
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{ color: theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1" sx={{ color: theme.palette.text.primary, pt: 3, pb: 2 }}>
          Describe the energy meter you'd like to add to Powersite. When you confirm, your request will be sent to our team, and we'll get in touch with you shortly.
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Please describe the energy meter you'd like to add..."
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            }
          }}
        />
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button 
          onClick={handleClose}
          sx={{ 
            color: theme.palette.text.secondary,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            }
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSend}
          variant="contained"
          sx={{
            backgroundColor: '#337A5C',
            '&:hover': {
              backgroundColor: '#2a6350',
            },
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 500,
            px: 3,
          }}
        >
          Send request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEnergyMeterRequestModal;
